import { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, Navigate, useLocation } from 'react-router'

import { useAuthorization } from 'app/application/presentation'
import { PublicRoutes } from 'app/application/types'
import { ArrowRightIcon } from 'app/common/presentation/icons'
import { useUser } from 'app/user/application'

import { Button, Input } from 'components'

import { AccessPage } from '../AccessPage'
import accessStyles from '../AccessPage/AccessPage.module.scss'
import styles from './LoginPage.module.scss'

interface LoginState {
  email?: string
  redirect?: string
}

const LoginPage = () => {
  const { t } = useTranslation('login')

  const { authorization } = useAuthorization()
  const location = useLocation()
  const { login } = useUser()

  const state = location.state as LoginState | null
  const { email: incomingEmail, redirect } = state ?? {}

  const [email, setEmail] = useState(incomingEmail ?? '')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  if (authorization) {
    return <Navigate to={redirect ?? '/'} replace />
  }

  const handleLogin = (e: SyntheticEvent) => {
    e.preventDefault()

    void login(email, password).then((loginResult) =>
      setError(loginResult.ok ? 'User sign in successful' : loginResult.val.message),
    )
  }

  return (
    <AccessPage>
      <div>
        <h1>{t('welcome')}</h1>
        <div className={accessStyles.message}>{t('message')}</div>
      </div>
      <form onSubmit={handleLogin}>
        <div className={styles.inputsArea}>
          <div className={accessStyles.inputs}>
            <Input
              autoComplete="username"
              autoFocus
              error={error ? ' ' : undefined}
              label={t('email')}
              mandatory
              onChange={setEmail}
              placeholder={t('placeholder.email')}
              value={email}
            />
            <Input
              autoComplete="current-password"
              error={error}
              label={t('password')}
              mandatory
              onChange={setPassword}
              placeholder={t('placeholder.password')}
              type="password"
              value={password}
            />
          </div>
          <div className={styles.resetPassword}>
            <Link to={PublicRoutes.ResetPassword}>{t('forgotPassword')}</Link>
          </div>
        </div>
        <Button disabled={!email || !password} type="submit" rightIcon={<ArrowRightIcon />}>
          {t('login')}
        </Button>
      </form>
    </AccessPage>
  )
}

export default LoginPage
